/* eslint-disable jsx-a11y/alt-text */
import React from "react";

import { Box, Typography, Grid } from "@mui/material";

import Image from "../components/image/Image";

import img1 from "../resources/images/community/1.jpg";
import img2 from "../resources/images/community/2.jpg";
import img3 from "../resources/images/community/3.jpg";
import img4 from "../resources/images/community/4.jpg";

export default function ActivitiesCommunity(props) {
  const nowMediaQuery = props.nowMediaQuery;

  return (
    <div className="section">
      <section className="contents">
        <Box mt={"150px"}>
          <Typography
            variant="h4"
            className="bold"
            textAlign={"center"}
            letterSpacing={2}
            fontSize={25}
            mb={1}
          >
            자조 공동체 지원
          </Typography>
          <Typography
            variant="subtitle1"
            fontSize={17}
            textAlign={"center"}
            lineHeight={2}
            mb={2}
          >
            “지역 내 독거 중장년층의 자립과 권익 향상을 위해 돌봄 공동체 활동을
            지원합니다.”
          </Typography>
          <Grid container justifyContent={"space-between"} mb={2}>
            <Grid size={{ xs: 12, sm: 12, md: 4 }}>
              <Box width={nowMediaQuery !== "mobile" ? "20vw" : "80vw"} mb={1}>
                <Image disabledEffect alt={""} src={img1} ratio={"16/9"} />
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 4 }}>
              <Box width={nowMediaQuery !== "mobile" ? "20vw" : "80vw"} mb={1}>
                <Image disabledEffect alt={""} src={img2} ratio={"16/9"} />
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 4 }}>
              <Box width={nowMediaQuery !== "mobile" ? "20vw" : "80vw"} mb={1}>
                <Image disabledEffect alt={""} src={img3} ratio={"16/9"} />
              </Box>
            </Grid>
          </Grid>
          <Box mt={5}>
            <Typography
              variant="subtitle1"
              fontSize={17}
              textAlign={"center"}
              lineHeight={2}
            >
              자조 모임 및 다양한 프로그램을 안내해 활동을 통한{" "}
              <strong>고립 해소</strong>를 돕습니다.
            </Typography>
            <Typography
              variant="subtitle1"
              fontSize={17}
              textAlign={"center"}
              lineHeight={2}
            >
              협동과 상생의 지역을 만들기 위해 힘을 모으는{" "}
              <strong>당사자 돌봄 조직</strong>(윗말협의회) 을 통해 어려운 순간
              서로를 돌보고 도와주며 가족처럼 함께합니다.
            </Typography>
          </Box>
        </Box>
      </section>

      <section className="contents">
        <div>
          <Typography variant="h5" mb={2}>
            <strong className="blue">물적 후원</strong>
          </Typography>

          <Grid container justifyContent={"space-between"}>
            <Grid size={{ xs: 12, sm: 12, md: 4 }}>
              <Box width={nowMediaQuery !== "mobile" ? "27vw" : "70vw"} mb={1}>
                <Image disabledEffect alt={""} src={img4} ratio={"6/4"} />
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
                width={nowMediaQuery !== "mobile" ? "35vw" : "80vw"}
                height={"100%"}
              >
                <Typography variant="subtitle1" fontSize={17} sx={{ my: 2 }}>
                  매월 다양한 기관의 지원을 통해 도시락, 식재료, 생필품 등을
                  후원받아 도움이 필요한 이웃들에게 전달하고 있습니다. <br />
                  <br />• KT&G 남서울지부 월 1회 도시락 후원 <br />• 성원실업 월
                  1회 식재료 지원 <br />• 서울 환경지킴이 년 1회 쌀 후원 <br />•
                  관악푸드뱅크 주 1회 빵 후원 <br />• 유가네곰탕 월 1회 식재료
                  지원
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </div>
      </section>
    </div>
  );
}
